import { styled } from '@mui/material';
import CardContent from '../CardContent';

export const TableCardContent = styled(CardContent)(({ theme }) => ({
  display: 'flex',
  minHeight: 0,
  borderRadius: `${theme.borderRadius.xl}px`,
  padding: theme.spacing(3),
  marginBottom: theme.spacing(2.5),
}));
